/**
 * Overlay
 */
import A11yDialog from 'a11y-dialog';

const overlayInstances = {
    /**
     * Lädt den Inhalt des Overlays
     * @param contentRoute
     * @returns {Promise<string>}
     */
    async loadOverlayContent(contentRoute) {
        try {
            const response = await fetch(contentRoute);
            return await response.text();
        } catch (err) {
            return '<div class="overlay__loading">Es ist ein Fehler aufgetreten.</div>';
        }
    },

    /**
     * Gibt die Lademeldung zurück
     * @returns {string}
     */
    overlayLoadingContent() {
        return '<div class="overlay__loading">Einen Moment bitte &hellip;</div>';
    },

    init() {
        const overlayElement = document.getElementById('js-overlay');
        if (overlayElement) {
            const main = document.querySelector('main');
            const dialog = new A11yDialog(overlayElement, main);
            const contentWrapper = document.querySelector('.js-overlay-content');

            dialog.on('show', (overlay, event) => {
                // Entfernt Workaround, dass der Backdrop initial nicht aufflackert
                overlay.classList.remove('is-loading');

                // Holt die Route zur Datenquelle aus dem Data-Attribut
                const {contentRoute} = event.target.dataset;

                // Setzt sicherheitshalber die Lademeldung
                contentWrapper.innerHTML = overlayInstances.overlayLoadingContent();

                // Lädt den Inhalt
                overlayInstances.loadOverlayContent(contentRoute).then((response) => {
                    contentWrapper.innerHTML = response;
                });
            });

            // Beim Schließen des Overlays wird der Inhalt wieder durch die Lademeldung ersetzt
            dialog.on('hide', () => {
                contentWrapper.innerHTML = overlayInstances.overlayLoadingContent();
            });
        }
    },
};

export default overlayInstances;
